module.exports = __webpack_public_path__ + "img/logout.09c89e12.svg";